module.exports = __webpack_public_path__ + "static/media/dropdownArrow.63188fbd.svg";